// extracted by mini-css-extract-plugin
module.exports = {"main":"PdfTemplate_main__6KMor","logo":"PdfTemplate_logo__etoTx","disclaimer":"PdfTemplate_disclaimer__HFn0C","search-fade-in":"PdfTemplate_search-fade-in__EzX5k"};